import { render, staticRenderFns } from "./InputCatalogName.vue?vue&type=template&id=48e52203"
import script from "./InputCatalogName.vue?vue&type=script&lang=ts"
export * from "./InputCatalogName.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports